import { useEffect, useMemo, useState } from 'react';
import { X } from '@phosphor-icons/react';
import styled from 'styled-components';
import { HoverBorderButton, ShadowBox } from '../../../elements';
import { useLocationHook } from '../../../hooks';
import { useWarehouseDetails } from '../../../screens/app/settings/warehouse';
import { EditLocationForm } from './EditLocation';
import { StoredAtLocationItems } from './StoredAtLocationItems';
import { MoveLocationForm } from './MoveLocationForm';

const Modal = styled(ShadowBox)`
  position: relative;
  z-index: 10;
  transition: all 0.5s;
  width: 570px;

  &.open {
    transform: translateX(0px);
  }

  &.close {
    transform: translateX(300px);
  }
`;

const PopupsContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Background = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
`;

export function EditBayPopup({ onClose, open, refreshData, locationData }) {
  const { warehouseId, warehouseData } = useWarehouseDetails();
  const [openSecondary, setOpenSecondary] = useState(true);
  const [moveLocationView, setMoveLocationView] = useState(false);

  const { data, loading: summaryLoading } = useLocationHook(
    locationData?._id,
    warehouseId,
  );

  const isImperial = useMemo(
    () => warehouseData?.dimensions?.measurementUnit === 'ft',
    [warehouseData],
  );

  const columns = [
    {
      text: 'Product Information',
      key: 'product_information',
      width: 2,
      textAlign: 'left',
    },
    {
      text: 'Available',
      key: 'available',
      textAlign: 'left',
      width: 1,
    },
    {
      text: 'Lots',
      textAlign: 'left',
      key: 'recipe',
      width: 1,
    },
    {
      text: '',
      textAlign: 'left',
      key: 'action',
      width: 1,
    },
  ];

  useEffect(() => {
    if (!open) {
      // if popup closes set the secondary back to view
      setOpenSecondary(true);
    }
  }, [open]);

  const toggleMoveLocationView = () => {
    setMoveLocationView(moveLocationView => !moveLocationView);
  };

  if (!open) {
    return <></>;
  }

  return (
    <PopupsContainer>
      <Background onClick={onClose} />
      <div className="d-flex align-items-start">
        <Modal open={open} onClose={onClose} className={openSecondary ? 'open' : 'close'}>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex align-items-center">
              <h3 className="m-0">
                {moveLocationView ? 'Move' : 'Edit'} Location in Level{' '}
                {locationData?.coordinates?.level} at Bay {locationData?.coordinates?.bay}
              </h3>
              <HoverBorderButton
                type="button"
                size="tiny"
                className="p-2 ml-2"
                onClick={() => setOpenSecondary(!openSecondary)}
              >
                {openSecondary ? 'Hide' : 'Show'} Contents
              </HoverBorderButton>
            </div>
            <X size={17} className="cursor-pointer" onClick={onClose} />
          </div>
          {moveLocationView ? (
            <MoveLocationForm
              locationId={locationData._id}
              toggleMoveLocationView={toggleMoveLocationView}
              onClose={onClose}
              refreshData={refreshData}
            />
          ) : (
            <EditLocationForm
              warehouseId={warehouseId}
              isImperial={isImperial}
              toggleMoveLocationView={toggleMoveLocationView}
              onClose={onClose}
              refreshData={refreshData}
              locationData={locationData}
            />
          )}
        </Modal>
        <StoredAtLocationItems
          openSecondary={openSecondary}
          setOpenSecondary={setOpenSecondary}
          locationData={locationData}
          columns={columns}
          data={data}
          summaryLoading={summaryLoading}
        />
      </div>
    </PopupsContainer>
  );
}
